/**
 * Amplitude "Page Section" for View Delivery/Pickup Widget (#18398).
 * Values must match the analytics spec / PM testing sheet.
 */
export const amplitudeDeliveryWidgetPageSection = {
  heroContentCard: 'Hero Content Card',
  nav: 'Nav',
  orderNowNav: 'Order Now Nav',
  belowHero: 'Below Hero',
  categoryCarousel: 'Category Carousel',
  buildYourOwnPack: 'Build Your Own Pack',
  categoryImages: 'Category Images',
  productImage: 'Product Image',
};
